import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { globalState, accessTokenKey, baseUrl } from "../utils/config";

import SingleJob from "./layouts/SingleJob";
import Loader from "./layouts/Loader";

function Jobs() {
    const navigate = useNavigate();
    const [fullTime, setFullTime] = useState([]);
    const [partTime, setPartTime] = useState([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    
    async function onInit() {
        setLoading(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            const formData = new FormData();
            formData.append("page", page);
            formData.append("time_zone", timeZone);

            const response = await axios.post(
                baseUrl + "/api/jobs/fetch",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setFullTime(response.data.full_time);
                setPartTime(response.data.part_time);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    useEffect(function () {
        onInit();
    }, []);

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Jobs</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">Jobs</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">Job Listing</h1>

                    { loading && (
                        <div className="row mb-5">
                            <div className="col-md-12 text-center">
                                <Loader />
                            </div>
                        </div>
                    ) }

                    <div className="tab-class text-center wow fadeInUp" data-wow-delay="0.3s">
                        <ul className="nav nav-pills d-inline-flex justify-content-center border-bottom mb-5">
                            <li className="nav-item">
                                <a className="d-flex align-items-center text-start mx-3 pb-3 active" data-bs-toggle="pill" href="#tab-1">
                                    <h6 className="mt-n1 mb-0">Full Time</h6>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="d-flex align-items-center text-start mx-3 me-0 pb-3" data-bs-toggle="pill" href="#tab-2">
                                    <h6 className="mt-n1 mb-0">Part Time</h6>
                                </a>
                            </li>
                        </ul>
                        <div className="tab-content">
                            <div id="tab-1" className="tab-pane fade show p-0 active">
                                { fullTime.map(function (j, index) {
                                    return (
                                        <SingleJob job={ j }
                                            key={ `job-${ j.id }` } />
                                    );
                                }) }

                                <Link className="btn btn-primary py-3 px-5" to="/search?nature=full_time">Browse More Jobs</Link>
                            </div>

                            <div id="tab-2" className="tab-pane fade show p-0">
                                { partTime.map(function (j, index) {
                                    return (
                                        <SingleJob job={ j }
                                            key={ `job-${ j.id }` } />
                                    );
                                }) }

                                <Link className="btn btn-primary py-3 px-5" to="/search?nature=part_time">Browse More Jobs</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Jobs;